import axios from "../axios";


/*
|--------------------------------------------------------------------------
| OFFERINGS
|--------------------------------------------------------------------------
*/


export const getOfferingsApi = async ({
  activeOnly = true,
  type = null,
  categoryId = null
} = {}) => {

  const params = {
    activeOnly
  };


  if (type) {
    params.type = type;
  }


  if (categoryId) {
    params.categoryId = categoryId;
  }


  const response = await axios.get(
    "/offerings",
    {
      params
    }
  );


  return response.data;
};


export const getOfferingApi = async (
  id
) => {

  const response = await axios.get(
    `/offerings/${id}`
  );


  return response.data;
};


export const createOfferingApi = async (
  data
) => {

  const response = await axios.post(
    "/offerings",
    data
  );


  return response.data;
};


export const updateOfferingApi = async (
  id,
  data
) => {

  const response = await axios.patch(
    `/offerings/${id}`,
    data
  );


  return response.data;
};


export const deleteOfferingApi = async (
  id
) => {

  const response = await axios.delete(
    `/offerings/${id}`
  );


  return response.data;
};


/*
|--------------------------------------------------------------------------
| IMAGES
|--------------------------------------------------------------------------
*/


export const getOfferingImagesApi = async (
  offeringId
) => {

  const response = await axios.get(
    `/offerings/${offeringId}/images`
  );


  return response.data;
};


export const createOfferingImageApi = async (
  offeringId,
  data
) => {

  const response = await axios.post(
    `/offerings/${offeringId}/images`,
    data
  );


  return response.data;
};


export const updateOfferingImageApi = async (
  offeringId,
  imageId,
  data
) => {

  const response = await axios.patch(
    `/offerings/${offeringId}/images/${imageId}`,
    data
  );


  return response.data;
};


export const deleteOfferingImageApi = async (
  offeringId,
  imageId
) => {

  const response = await axios.delete(
    `/offerings/${offeringId}/images/${imageId}`
  );


  return response.data;
};


/*
|--------------------------------------------------------------------------
| PRICING PLANS
|--------------------------------------------------------------------------
*/


export const getPricingPlansApi = async (
  offeringId,
  activeOnly = true
) => {

  const response = await axios.get(
    `/offerings/${offeringId}/pricing-plans`,
    {
      params: {
        activeOnly
      }
    }
  );


  return response.data;
};


export const createPricingPlanApi = async (
  offeringId,
  data
) => {

  const response = await axios.post(
    `/offerings/${offeringId}/pricing-plans`,
    data
  );


  return response.data;
};


export const updatePricingPlanApi = async (
  offeringId,
  planId,
  data
) => {

  const response = await axios.patch(
    `/offerings/${offeringId}/pricing-plans/${planId}`,
    data
  );


  return response.data;
};


export const deletePricingPlanApi = async (
  offeringId,
  planId
) => {

  const response = await axios.delete(
    `/offerings/${offeringId}/pricing-plans/${planId}`
  );


  return response.data;
};